import React from 'react';
import LoginForm from './components/LoginForm';

export default function Login({ onLogin }) {
  return <LoginForm onLogin={onLogin} />;
}